import { Col, Container, Image, Row } from "react-bootstrap";
import MediaQueryTool from "../../utils/MediaQueryTool";
import sugarno from "../../assets/pfp.png";
import firstlogo from "../../assets/IMG_0299.svg";
import secondlogo from "../../assets/IMG_0300.svg";
import thirdlogo from "../../assets/IMG_0301.svg";
import splash from "../../assets/splash_about_me.png";
import discord from "../../assets/discord.svg";
import phone from "../../assets/telephone.svg";
import insta from "../../assets/instagram.svg";
import email from "../../assets/envelope.svg";
import facebook from "../../assets/facebook.svg";

const Resume = () => {
  const mediaQueryTool = MediaQueryTool();

  const logoList = [secondlogo, thirdlogo, firstlogo];

  return (
    <Container className="mt-4">
      {mediaQueryTool.isLG || mediaQueryTool.isXL ? (
        <Container
          style={{
            marginTop: 100,
          }}
        >
          <Row style={{ zIndex: 1, position: "relative" }}>
            <Col lg={4}></Col>
            <Col lg={6}>
              <div className="resumeContainerOutline">
                <Container className="resumeContainer">
                  <h2 style={{ fontWeight: "bold" }}>GreenParadise Sdn Bhd </h2>
                  <p style={{ fontSize: 18 }}>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(Graphic
                    Designer) Jan 17 - Dec 20
                  </p>
                  <h2 style={{ fontWeight: "bold" }}>Aoi Art Class</h2>
                  <p style={{ fontSize: 18 }}>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(Art Tutor)
                    Dec 24 - Current
                  </p>
                </Container>
              </div>
            </Col>
            <Col lg={2}></Col>
          </Row>
          <Row className="mt-5" style={{ zIndex: -1 }}>
            <Col lg={12}>
              <Container
                style={{
                  marginTop: -100,
                  display: "flex",
                  width: "100%",
                  height: "15rem",
                }}
                className="resumeContainer2"
              >
                <Image
                  style={{
                    marginTop: -190,
                    width: "20rem",
                    height: "20rem",
                  }}
                  src={sugarno}
                />
                <div style={{ justifySelf: "center", alignSelf: "center" }}>
                  <div
                    className="neon-text"
                    style={{
                      fontFamily: "CyberpunkFont",
                      marginLeft: -165,
                      fontSize: 100,
                      letterSpacing: 10,
                    }}
                  >
                    Sugarno
                  </div>
                  <div
                    className="neon-text"
                    style={{ fontSize: 35, marginTop: -60, marginLeft: 90 }}
                  >
                    amiraraja
                  </div>
                </div>
              </Container>
            </Col>
          </Row>

          <Row>
            <Col lg={9}></Col>
            <Col lg={3}>
              <div
                style={{
                  marginTop: !mediaQueryTool.isXS ? -100 : undefined,
                  padding: "10px 30px",
                }}
              >
                <Image
                  src={splash}
                  style={{
                    position: "absolute",
                    marginTop: -210,
                    marginLeft: -160,
                    zIndex: 3,
                  }}
                />
                <div
                  style={{
                    zIndex: 4,
                    position: "absolute",
                    marginLeft: 30,
                    marginTop: 30,
                    fontSize: 18,
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <a
                    href="tel:+60172496409"
                    style={{
                      textDecoration: "none",
                      color: "white",
                      cursor: "pointer",
                    }}
                  >
                    <Image
                      height={20}
                      width={20}
                      src={phone}
                      style={{ marginRight: 10 }}
                    />
                    +6017-249 6409
                  </a>
                  <a
                    href="mailto:sugarnno@gmail.com"
                    className="mt-2"
                    style={{
                      textDecoration: "none",
                      color: "white",
                      cursor: "pointer",
                    }}
                  >
                    <Image
                      height={20}
                      width={20}
                      src={email}
                      style={{ marginRight: 10 }}
                    />
                    sugarnno@gmail.com
                  </a>
                  <a
                    href="https://www.instagram.com/sugarno99?igsh=aHFiemdvMjh5cmNo"
                    target="_blank"
                    rel="noreferrer"
                    className="mt-2"
                    style={{
                      textDecoration: "none",
                      color: "white",
                      cursor: "pointer",
                    }}
                  >
                    <Image
                      height={20}
                      width={20}
                      src={insta}
                      style={{
                        marginRight: 10,
                      }}
                    />
                    sugarno99
                  </a>
                  <a
                    href="https://www.facebook.com/share/14sRJ5gQ4z/"
                    target="_blank"
                    rel="noreferrer"
                    className="mt-2"
                    style={{
                      textDecoration: "none",
                      color: "white",
                      cursor: "pointer",
                    }}
                  >
                    <Image
                      height={20}
                      width={20}
                      src={facebook}
                      style={{ marginRight: 10 }}
                    />
                    Sugar No
                  </a>
                  <div className="mt-2" style={{ color: "white" }}>
                    <Image
                      height={20}
                      width={20}
                      src={discord}
                      style={{ marginRight: 10 }}
                    />
                    amiraraja
                  </div>
                </div>
              </div>
            </Col>
          </Row>

          <Row className="mt-5">
            <Col lg={3}>
              <div
                style={{
                  marginTop: -110,
                  marginLeft: 45,
                }}
                className="resumeContainerOutline"
              >
                <Container className="resumeContainer">
                  <h2>Art</h2>
                  <ul style={{ fontSize: 18, backgroundColor: "transparent" }}>
                    <li>Sketching</li>
                    <li>Character Design</li>
                    <li>Illustration</li>
                  </ul>

                  <h2>Personal</h2>
                  <ul
                    style={{
                      fontSize: 18,
                      backgroundColor: "transparent",
                      textDecoration: "none",
                    }}
                  >
                    <li>Adaptive</li>
                    <li>Respecting Deadline</li>
                    <li>Problem Solving Skill</li>
                  </ul>
                </Container>
              </div>
            </Col>
            <Col lg={6}>
              <div
                style={{
                  marginLeft: 45,
                  marginTop: -20,
                }}
                className="resumeContainerOutline"
              >
                <Container className="resumeContainer">
                  <h2 style={{ fontWeight: "bold" }}>Diploma in Multimedia </h2>

                  <p style={{ fontSize: 18, whiteSpace: "pre" }}>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;TARUMT KL
                    Branch
                  </p>
                </Container>
              </div>
            </Col>
          </Row>
          <Row
            style={{
              marginTop: -90,
              marginLeft: -90,
            }}
          >
            <Col lg={4}></Col>
            <Col lg={6}>
              {logoList.map((logo, index) => {
                return (
                  <Image
                    key={index}
                    style={{ height: 100, marginRight: 15 }}
                    src={logo}
                  />
                );
              })}
            </Col>
          </Row>
        </Container>
      ) : (
        <Container
          style={{
            marginTop: 40,
          }}
        >
          <Row className="mt-4" style={{ zIndex: 1, position: "relative" }}>
            <Col>
              <div className="resumeMobileContainerOutline">
                <Container className="resumeMobileContainer">
                  <h4 style={{ fontWeight: "bold" }}>GreenParadise Sdn Bhd </h4>
                  <p style={{ fontSize: 14 }}>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(Graphic
                    Designer) Jan 17 - Dec 20
                  </p>
                  <h4 style={{ fontWeight: "bold" }}>Aoi Art Class</h4>
                  <p style={{ fontSize: 14 }}>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(Art Tutor)
                    Dec 24 - Current
                  </p>
                </Container>
              </div>
            </Col>
            <Col lg={2}></Col>
          </Row>
          <Row>
            <Col xs={12}>
              <div className="resumeMobileContainerOutline mt-3">
                <Container className="resumeMobileContainer">
                  <h4>Art</h4>
                  <ul style={{ fontSize: 14, backgroundColor: "transparent" }}>
                    <li>Sketching</li>
                    <li>Character Design</li>
                    <li>Illustration</li>
                  </ul>

                  <h4>Personal</h4>
                  <ul
                    style={{
                      fontSize: 14,
                      backgroundColor: "transparent",
                      textDecoration: "none",
                    }}
                  >
                    <li>Adaptive</li>
                    <li>Respecting Deadline</li>
                    <li>Problem Solving Skill</li>
                  </ul>
                </Container>
              </div>
            </Col>
            <Col xs={12}>
              <div className="resumeMobileContainerOutline mt-3">
                <Container className="resumeMobileContainer">
                  <h4 style={{ fontWeight: "bold" }}>Diploma in Multimedia </h4>

                  <p style={{ fontSize: 14, whiteSpace: "pre" }}>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;TARUMT KL
                    Branch
                  </p>
                </Container>
              </div>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col style={{ display: "flex", justifyContent: "center" }}>
              {logoList.map((logo, index) => {
                return (
                  <Image
                    key={index}
                    style={{ height: 70, marginRight: 10 }}
                    src={logo}
                  />
                );
              })}
            </Col>
          </Row>
        </Container>
      )}
    </Container>
  );
};

export default Resume;
